import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import 'whatwg-fetch';
import {ChangePasswordEpic} from '../actions/auth.actions';
import {connect} from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';
import Paper from 'material-ui/Paper';
import * as colors from 'material-ui/styles/colors';
import muiThemeable from 'material-ui/styles/muiThemeable';
import ErrorBlock from '../components/ErrorBlock';
import {orange500, green500} from 'material-ui/styles/colors';
const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
const mediumRegex = new RegExp('^((15(?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})');

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      passwordStrength: ''
    };
  }

  handleClick = async (event) => {
    this.props.changePasswordAction(this.props.username, this.state.password, this.state.newPassword);
  }

  handleKeyPress = (target) => {
    if(target.charCode===13 && (this.state.confirmPassword && this.state.newPassword && this.state.currentPassword)) {
      this.handleClick(target);
    }

  }

  analyzePasswordStrength(password) {
    let passwordStrength = '';
    if (password === '') {
      passwordStrength = '';
    } else if (strongRegex.test(password)) {
      passwordStrength = 'strong';
    } else if (mediumRegex.test(password)) {
      passwordStrength = 'medium';
    } else {
      passwordStrength = 'weak';
    }
    this.setState({passwordStrength});
  }

  render() {

    const styles = {
      header: {
        color: colors.fullWhite
      },
      headerText: {
        color: 'white',
        bottom: '12px',
        left: 10,
        position:'absolute',
        fontSize: '1.3em'
      },
      paperContent: {
        margin: 10
      },
      fields: {
        width: 350
      },
      passwordErrorStyle: {
        color: this.state.passwordStrength === 'medium' ? orange500 
          : 
          this.state.passwordStrength === 'strong' ? green500 
          :
          this.state.passwordStrength === 'weak' ? 'red' 
          : 
          'black'
      }

    }

    let passwordErrorText = this.state.passwordStrength === 'medium' ? 'Password strength is medium' 
      : 
      this.state.passwordStrength === 'strong' ? 'Password strength is strong'
      :
      this.state.passwordStrength === 'weak' ? 'Password strength is too weak' 
      : 
      '';

    return (<div style={{textAlign: 'center'}}>
      {
        this.props.loading? 
        <div style={{textAlign: 'center'}}><CircularProgress style={{position:'relative', }}/></div> :
        <div style={{display:'inline-block', width: 400, padding: 10}}>
          <Paper zDepth={2}>
            <div className="loginHeader">
              <div style={styles.headerText}>Change Password</div>
            </div>
               {this.props.loginError ? 
                <ErrorBlock errorText={this.props.loginError.toString()}/>
                : 
                null
              }
              <TextField
                style={styles.fields}
                type="password"
                hintText=""
                id="currentPassword"
                floatingLabelText="Current Password"
                onChange = {(event,newValue) => {this.setState({password:newValue});}}
              />
              <br/>
              <TextField
                style={styles.fields}
                type="password"
                hintText=""
                id="newPassword"
                floatingLabelText="New Password"
                errorText={passwordErrorText}
                errorStyle={styles.passwordErrorStyle}
                onChange = {(event,newValue) => {this.analyzePasswordStrength(newValue); this.setState({newPassword:newValue});}}
                onKeyPress={this.handleKeyPress}
              />
              <TextField
                style={styles.fields}
                type="password"
                id="confirmPassword"
                hintText=""
                floatingLabelText="Confirm Password"
                onChange = {(event,newValue) => this.setState({confirmPassword:newValue})}
                onKeyPress={this.handleKeyPress}
              />
              <br/>
              <div style={{padding:15}}>
              <RaisedButton label="Submit" onKeyPress={this.handleKeyPress} fullWidth={true} primary={true} onClick={(event) => this.handleClick(event)} disabled={(!this.state.username && !this.state.password) || ['medium', 'strong'].indexOf(this.state.passwordStrength) === -1}/>
              </div>
             
          </Paper>
        </div>
      }</div>);
  }
}

const mapStateToProps = ({authEndpoint}) => ({
  loading: authEndpoint.fetchInProgress,
  loginError: authEndpoint.fetchError,
  username: authEndpoint.username
})

const mapDispatchToProps = (dispatch) => {
  return {
    changePasswordAction : (username,password, newPassword) => dispatch(ChangePasswordEpic(username,password, newPassword))
  }
}

export default muiThemeable()(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/containers/ChangePassword.js